<template>
    <div style="margin-top: 20px;">
        <el-table v-loading="showLoading" :data="items" style="width: 100%;" class="JY-table-a">
            <el-table-column prop="OrderYunDanNo" width="100" label="轨迹">
                <template slot-scope="scope">
                        <a href="javascript:;" @click="openLocationHistory(scope.row)">查看</a>
</template>
            </el-table-column>
            <el-table-column prop="OrderYunDanNo" width="100" label="电子运单号">
            </el-table-column>
            <el-table-column prop="ChePaiHao" width="100" label="车牌号">
            </el-table-column>
            <el-table-column prop="ShiJiDriverUserName" width="150" label="实际驾驶人">
            </el-table-column>
            <el-table-column prop="BaoJiaUserID" width="150" label="承运人">
            </el-table-column>
            <el-table-column prop="ChuFaDi" width="180" label="出发地">
            </el-table-column>
            <el-table-column prop="DaoDaDi" label="到达地" width="180">
            </el-table-column>
            <el-table-column prop="QiYunRiQi" label="出发日期" width="150">
            </el-table-column>
            <el-table-column prop="DaoDaRiQi" label="到达日期"  width="150">
            </el-table-column>
            <el-table-column prop="FaHuoZhongLiang" label="重量信息"  width="280">
<template slot-scope="scope">
    <span class="tip-span">发货重量:{{scope.row.FaHuoZhongLiang}}</span>
    <span class="tip-span">到场重量:{{scope.row.DaoChangZhongLiang}}</span>
    <span class="tip-span">计费重量:{{scope.row.JiFeiZhongLiang}}</span>
</template>
            </el-table-column>
            <el-table-column prop="IsQueRenTiHuo" width="200" label="司机确认提货单">
            </el-table-column>
            <el-table-column prop="IsQueRenDaoDa" width="200" label="司机确认到达" >
            </el-table-column>
            <el-table-column prop="IsEnabled" label="状态">
            </el-table-column>
        </el-table>
        <div class="row mt10" style="margin-left: 0; margin-top: 10px;">
            <el-pagination @current-change="loadMore" background :page-size="search.PageSize" layout="total, prev, pager, next" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import api from "../api";
    export default {
        props: ["orderNo"],
        data() {
            return {
                dialogVisible: false,
                showLoading: false,
                items: [],
                total: 0,
                search: {
                    PageNo: 1,
                    PageSize: 20,
                    YunShuStatus: "",
                    ChuFaRiQi_S: "",
                    ChuFaRiQi_E: "",
                    Keywords: "",
                    OrderNo: this.orderNo,
                    OrderYunDanNo: ""
                }
            };
        },
        methods: {
            loadMore(n) {
                this.search.PageNo = n;
                this.loadItems();
            },
            reload() {
                this.search.PageNo = 1;
                this.loadItems();
            },
            loadItems() {
                let _this = this;
                _this.showLoading = true;
                api.getYunDans(_this.search).then(res => {
                    _this.showLoading = false;
                    if (res.data.Succeed) {
                        _this.items = res.data.Data.Data;
                        _this.total = res.data.Data.totalItemCount;
                    }
                });
            },
            openLocationHistory(item) {
                var url = process.env.BASE_API + '/Apps/JYJYManage/Map/Index?yunDanNo=' + item.OrderYunDanNo
                window.open(url)
            }
        },
        mounted() {
            this.loadItems();
        }
    };
</script>

<style>
    .JY-items-list,
    .JY-items-search {
        width: 100%;
    }
    span.el-tag {
        margin-right: 5px;
    }
    .el-table th.gutter {
        display: table-cell !important;
    }
    /* .tip-span{
            display: block;
        } */
</style>




// WEBPACK FOOTER //
// src/components/yundanTable.vue